.popup {
  composes: popup from './utils.module.css';
  padding: 0.25rem;
}

.control {
  display: flex;
  justify-content: var(--h5w-overflowMenu-control--justify, flex-end);
  min-height: calc(var(--h5w-btn--height, 1.875rem) + 0.5rem);
}
